import { render } from "./ViewStudentClassRecordDialog.vue?vue&type=template&id=4f864cfd&scoped=true"
import script from "./ViewStudentClassRecordDialog.vue?vue&type=script&lang=js"
export * from "./ViewStudentClassRecordDialog.vue?vue&type=script&lang=js"

import "./ViewStudentClassRecordDialog.vue?vue&type=style&index=0&id=4f864cfd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f864cfd"]])

export default __exports__